module.exports = __webpack_public_path__ + "media/images/favicon-091c662d00b1edd7b2b80801acbe1a9b.ico";